import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { services } from "@/data/services";

const relatedLinks = [
  { label: "Our Specialist", to: "/about#specialist", icon: "ri-user-heart-line" },
  { label: "Read Our Blog", to: "/blog", icon: "ri-article-line" },
  { label: "About Ortho Spine Care", to: "/about", icon: "ri-hospital-line" },
  { label: "Book an Appointment", to: "/appointment", icon: "ri-calendar-check-line" },
];

/**
 * The individual services offered under the two care areas, plus a compact band
 * of related internal links (Specialist, Blog, About, Appointment).
 */
export default function RelatedServices() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Every service, under one roof"
          title="Specialist services across bone, joint and spine care"
          description="Each service has its own detail page covering what it involves, the conditions treated and the treatment options available."
        />

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              className="reveal group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 hover:shadow-[0_28px_55px_-38px_rgba(15,40,80,0.6)]"
            >
              <div className="h-44 w-full overflow-hidden bg-background-100">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  title={`${service.title} — Ortho Spine Care Trichy`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${service.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{service.title}</h3>
                <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-foreground-600">{service.summary}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 font-label text-sm font-semibold text-primary-700">
                  Learn more
                  <i
                    className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4">
          {relatedLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="reveal flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${link.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <span className="font-label text-sm font-semibold text-foreground-800">{link.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}